import { useEffect } from 'react';

function Terms() {
  useEffect(() => {
    window.location.replace('/terms.html');
  }, []);

  return null;
}

export default Terms;
